/* ============================================
   Legacy Timeless Jewel — Custom JavaScript
   ============================================ */
(function () {
  'use strict';

  /* ---- Sticky Header scroll shadow ---- */
  function initStickyHeader() {
    var wrap = document.querySelector('.ltj-sticky-wrap');
    if (!wrap) return;
    window.addEventListener('scroll', function () {
      wrap.classList.toggle('ltj-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ---- Cart page helpers (only run if the cart page is rendered).
         Three small pieces:
           1. Quantity steppers — wire +/- buttons to the existing
              hidden quantity input + dispatch `change` so theme.js
              (when cart_ajax_enable is on) performs the server update.
           2. Free-shipping progress bar — after any qty change, refetch
              /cart.js and recompute the bar + message.
           3. "This is a gift" checkbox — sync to a cart attribute via
              /cart/update.js so it persists across AJAX line updates. ---- */
  function initCart() {
    var cartRoot = document.querySelector('[data-section-type="cart-template"]');
    if (!cartRoot) return;

    initCartSteppers();
    initCartShipProgress();
    initCartGift();
  }

  function initCartSteppers() {
    var steppers = document.querySelectorAll('[data-cart-stepper]');
    if (!steppers.length) return;
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('input[data-quantity-input]');
      if (!input) return;
      stepper.querySelectorAll('.ltj-cart-stepper__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var current = parseInt(input.value, 10);
          if (isNaN(current)) current = 0;
          var next = Math.max(0, current + step);
          if (next === current) return;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    });
  }

  function initCartShipProgress() {
    var progress = document.querySelector('[data-cart-ship-progress]');
    if (!progress) return;
    var threshold = parseInt(progress.getAttribute('data-ship-threshold'), 10);
    if (!threshold) return;
    var fill = progress.querySelector('[data-ship-fill]');
    var msg = progress.querySelector('[data-ship-msg]');

    function formatPrice(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars;
    }

    function update(totalCents) {
      if (typeof totalCents !== 'number') return;
      var qualified = totalCents >= threshold;
      progress.classList.toggle('is-qualified', qualified);
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (qualified) {
          msg.innerHTML = "You've qualified for free shipping";
        } else {
          msg.innerHTML = 'Add <strong>' + formatPrice(threshold - totalCents) +
                          '</strong> more for free shipping';
        }
      }
    }

    function refresh() {
      if (!window.fetch) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { if (data) update(data.total_price); })
        .catch(function () { /* noop */ });
    }

    // Re-fetch after any quantity change inside the cart page.
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (!e.target.matches || !e.target.matches('[data-quantity-input]')) return;
      // Let theme.js's AJAX update happen first, then poll the truth.
      setTimeout(refresh, 600);
    });

    // Also refresh when the user submits a remove link via AJAX.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && t.closest('[data-cart-remove]')) {
        setTimeout(refresh, 800);
      }
    });
  }

  function initCartGift() {
    var box = document.querySelector('[data-ltj-gift]');
    if (!box) return;
    box.addEventListener('change', function () {
      if (!window.fetch) return;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { Gift: box.checked ? 'Yes' : '' } })
      }).catch(function () { /* noop */ });
    });
  }

  /* ---- Back button (product page).
         Uses history.back() when the user actually has a referrer
         within this domain. Otherwise navigates to the fallback URL
         (the current collection, or /collections/all) so the button
         is never a dead-end. ---- */
  function initBackLink() {
    var buttons = document.querySelectorAll('[data-ltj-back]');
    if (!buttons.length) return;

    var sameOriginReferrer = (function () {
      if (!document.referrer) return false;
      try {
        var ref = new URL(document.referrer);
        return ref.origin === window.location.origin &&
               ref.pathname !== window.location.pathname;
      } catch (e) { return false; }
    })();

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (sameOriginReferrer && window.history.length > 1) {
          window.history.back();
          return;
        }
        var fallback = btn.getAttribute('data-fallback');
        if (fallback) {
          window.location.href = fallback;
        }
      });
    });
  }

  /* ---- Back to Top ---- */
  function initBackToTop() {
    var btn = document.getElementById('ltj-back-to-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('ltj-visible', window.scrollY > 450);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Ticker duplicate for seamless loop ---- */
  function initTicker() {
    var ticker = document.querySelector('.announcement-bar__ticker');
    if (!ticker) return;
    var clone = ticker.cloneNode(true);
    ticker.parentNode.appendChild(clone);
  }

  /* ---- Mobile Slide Drawer ---- */
  function initMobileDrawer() {
    var navWrapper = document.querySelector('.mobile-nav-wrapper');
    var overlay = document.getElementById('ltj-mobile-overlay');
    if (!navWrapper || !overlay) return;

    var closeBtn = document.createElement('button');
    closeBtn.className = 'ltj-mobile-close';
    closeBtn.setAttribute('aria-label', 'Close menu');
    closeBtn.innerHTML = '&times;';
    var titleEl = document.createElement('span');
    titleEl.className = 'ltj-mobile-header-title';
    titleEl.textContent = 'Menu';
    navWrapper.insertBefore(closeBtn, navWrapper.firstChild);
    navWrapper.insertBefore(titleEl, navWrapper.firstChild);

    // The drawer lives inside .ltj-sticky-wrap (position:sticky; z-index:200),
    // whose stacking context traps the drawer's z-index. Move the drawer and its
    // overlay to <body> so they layer at the document root and the overlay can sit
    // BEHIND the drawer (not on top of it, which blurred/blocked the menu).
    document.body.appendChild(overlay);
    document.body.appendChild(navWrapper);

    function open() {
      navWrapper.style.transform = '';   // drop any inline transform Debut may have set
      navWrapper.classList.add('ltj-drawer-open');
      overlay.classList.add('ltj-active');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      navWrapper.style.transform = '';   // let our CSS class control the slide-out
      navWrapper.classList.remove('ltj-drawer-open');
      overlay.classList.remove('ltj-active');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.js-mobile-nav-toggle').forEach(function (btn) {
      // Capture phase + stopImmediatePropagation blocks Debut's native MobileNav
      // (bubble-phase) handler so only this drawer runs — no inline-transform fight.
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        navWrapper.classList.contains('ltj-drawer-open') ? close() : open();
      }, true);
    });

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900) close();
    });
  }

  /* ---- FAQ Accordion ---- */
  function initFAQ() {
    document.querySelectorAll('.ltj-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.ltj-faq__item');
        var isOpen = item.classList.contains('ltj-open');
        document.querySelectorAll('.ltj-faq__item.ltj-open').forEach(function (el) {
          el.classList.remove('ltj-open');
        });
        if (!isOpen) item.classList.add('ltj-open');
      });
    });
  }

  /* ---- Education Tabs ---- */
  function initEducationTabs() {
    document.querySelectorAll('.ltj-education').forEach(function (section) {
      section.querySelectorAll('.ltj-education__tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.tab;
          section.querySelectorAll('.ltj-education__tab-btn').forEach(function (b) {
            b.classList.toggle('ltj-active', b === btn);
          });
          section.querySelectorAll('.ltj-education__panel').forEach(function (panel) {
            var active = panel.dataset.tab === target;
            panel.classList.toggle('ltj-active', active);
            if (active) {
              panel.querySelectorAll('.ltj-education__scale-fill').forEach(function (fill) {
                fill.style.width = fill.dataset.width || '0%';
              });
            }
          });
        });
      });

      // Activate first tab
      var firstBtn = section.querySelector('.ltj-education__tab-btn');
      if (firstBtn) firstBtn.click();
    });
  }

  /* ---- Wishlist (localStorage) ---- */
  var WL_KEY = 'ltj_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WL_KEY, JSON.stringify(list));
  }
  function isWishlisted(handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  }
  function toggleWishlist(item) {
    var list = getWishlist();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx >= 0) { list.splice(idx, 1); }
    else { list.push(item); }
    saveWishlist(list);
    updateAllBadges();
    return idx < 0; // true = now wishlisted
  }
  function updateAllBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.ltj-wl-badge').forEach(function (b) {
      b.textContent = count;
      b.classList.toggle('ltj-show', count > 0);
    });
  }

  function initWishlistButtons() {
    // Small heart buttons on product cards
    document.querySelectorAll('.ltj-wishlist-btn').forEach(function (btn) {
      var handle = btn.dataset.handle;
      if (!handle) return;
      if (isWishlisted(handle)) btn.classList.add('ltj-wishlisted');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var wishlisted = toggleWishlist({
          handle: handle,
          title: btn.dataset.title || '',
          image: btn.dataset.image || '',
          price: btn.dataset.price || '',
          url: btn.dataset.url || ''
        });
        btn.classList.toggle('ltj-wishlisted', wishlisted);
      });
    });

    // Large wishlist button on product page
    document.querySelectorAll('.ltj-product-wishlist-btn').forEach(function (btn) {
      var handle = btn.dataset.handle;
      if (!handle) return;
      var textEl = btn.querySelector('.ltj-wishlist-text');
      if (isWishlisted(handle)) {
        btn.classList.add('ltj-wishlisted');
        if (textEl) textEl.textContent = 'Wishlisted';
      }
      btn.addEventListener('click', function () {
        var wishlisted = toggleWishlist({
          handle: handle,
          title: btn.dataset.title || '',
          image: btn.dataset.image || '',
          price: btn.dataset.price || '',
          url: btn.dataset.url || ''
        });
        btn.classList.toggle('ltj-wishlisted', wishlisted);
        if (textEl) textEl.textContent = wishlisted ? 'Wishlisted' : 'Add to Wishlist';
      });
    });

    updateAllBadges();
  }

  /* ---- Wishlist Page ---- */
  function initWishlistPage() {
    var container = document.getElementById('ltj-wishlist-container');
    if (!container) return;
    var countEl = document.getElementById('ltj-wishlist-count');
    var countLabel = document.getElementById('ltj-wishlist-count-label');

    function render() {
      var list = getWishlist();
      if (countEl) countEl.textContent = list.length;
      if (countLabel) countLabel.textContent = list.length === 1 ? 'saved piece' : 'saved pieces';

      if (!list.length) {
        container.innerHTML =
          '<div class="ltj-wishlist-empty">' +
            '<span class="ltj-wishlist-empty__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.7-7.5 1.1-1.1a5.5 5.5 0 0 0 0-7.8Z"/></svg></span>' +
            '<h2>Your wishlist is waiting</h2>' +
            '<p>Save the natural gemstones and handcrafted pieces you love. They will stay here so you can compare, revisit, and choose in your own time.</p>' +
            '<div class="ltj-wishlist-empty__actions">' +
              '<a href="/collections/all" class="ltj-wishlist-empty__btn">Explore the collection</a>' +
              '<a href="/pages/build-your-jewelry" class="ltj-wishlist-empty__btn ltj-wishlist-empty__btn--ghost">Create your jewelry</a>' +
            '</div>' +
          '</div>';
        return;
      }

      var html = '<div class="ltj-wishlist-grid">';
      list.forEach(function (item) {
        var itemUrl = item.url || '/collections/all';
        html +=
          '<article class="ltj-wishlist-item">' +
            '<div class="ltj-wishlist-item__media">' +
              '<a href="' + escHtml(itemUrl) + '" aria-label="View ' + escHtml(item.title) + '">' +
                (item.image ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '" loading="lazy" decoding="async">' : '') +
              '</a>' +
              '<span class="ltj-wishlist-item__badge">Saved</span>' +
              '<button type="button" class="ltj-wishlist-remove" data-handle="' + escHtml(item.handle) + '" aria-label="Remove ' + escHtml(item.title) + ' from wishlist"><span aria-hidden="true">&times;</span></button>' +
            '</div>' +
            '<div class="ltj-wishlist-item-info">' +
              '<p class="ltj-wishlist-item-kicker">Your selection</p>' +
              '<h2 class="ltj-wishlist-item-title"><a href="' + escHtml(itemUrl) + '">' + escHtml(item.title) + '</a></h2>' +
              '<p class="ltj-wishlist-item-price">' + escHtml(item.price) + '</p>' +
              '<a class="ltj-wishlist-item-action" href="' + escHtml(itemUrl) + '">View details <span aria-hidden="true">&rarr;</span></a>' +
            '</div>' +
          '</article>';
      });
      html += '</div>';
      container.innerHTML = html;

      container.querySelectorAll('.ltj-wishlist-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var list2 = getWishlist().filter(function (item) { return item.handle !== btn.dataset.handle; });
          saveWishlist(list2);
          updateAllBadges();
          render();
        });
      });
    }
    render();
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ---- Jewelry Builder ---- */
  function initJewelryBuilder() {
    var builder = document.getElementById('ltj-jewelry-builder');
    if (!builder) return;

    var panels = builder.querySelectorAll('.ltj-builder__panel');
    var totalSteps = panels.length;
    var currentStep = 1;
    var selections = {};
    var hasInteracted = false;     // becomes true on first user pick / step advance

    /* ---- Persistence: localStorage for cross-session restore +
            URL params so the user can share a design link. URL takes
            precedence over localStorage so a shared link wins. ---- */
    var LS_KEY = 'ltjBuilder.selections';
    var SS_SUCCESS_KEY = 'ltjBuilder.success';

    /* Compact keys for URL params so the URL stays readable */
    var URL_KEYS = {
      jewelry_type: 'type',
      size:         'size',
      ring_size:    'ring',
      length:       'len',
      gemstone:     'stone',
      stone_mm:     'mm',
      metal:        'metal'
    };
    var URL_KEYS_REVERSE = {};
    Object.keys(URL_KEYS).forEach(function (k) { URL_KEYS_REVERSE[URL_KEYS[k]] = k; });

    function persistState() {
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(selections));
      } catch (e) { /* private mode / quota */ }

      /* URL — only update once the user has actually started selecting,
         so landing on the page doesn't clutter the URL. */
      if (!hasInteracted || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        Object.keys(URL_KEYS).forEach(function (k) {
          var v = selections[k];
          if (v) url.searchParams.set(URL_KEYS[k], v);
          else url.searchParams.delete(URL_KEYS[k]);
        });
        window.history.replaceState(null, '', url.toString());
      } catch (e) { /* noop */ }
    }

    function hydrateState() {
      /* Order: URL > localStorage. URL params present? Use them and
         ignore localStorage (someone shared a design link). */
      var fromUrl = false;
      try {
        var params = new URLSearchParams(window.location.search);
        Object.keys(URL_KEYS_REVERSE).forEach(function (urlK) {
          var v = params.get(urlK);
          if (v) {
            selections[URL_KEYS_REVERSE[urlK]] = v;
            fromUrl = true;
          }
        });
      } catch (e) { /* noop */ }

      if (!fromUrl) {
        try {
          var raw = localStorage.getItem(LS_KEY);
          if (raw) {
            var parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') selections = parsed;
          }
        } catch (e) { /* noop */ }
      }

      /* Reflect the restored selections back into the UI's click state */
      Object.keys(selections).forEach(function (key) {
        var val = selections[key];
        if (!val) return;
        var group = builder.querySelector('[data-builder-key="' + key + '"]');
        if (!group) return;
        var targets = group.querySelectorAll('[data-value]');
        var matchedSelection = false;
        targets.forEach(function (el) {
          if (el.dataset.value === val) {
            el.classList.add('ltj-selected');
            matchedSelection = true;
          }
        });
        // Spreadsheet inventory is the source of truth. Remove selections from
        // older shared links/local storage when that option no longer exists.
        if (!matchedSelection) delete selections[key];
      });
    }

    function goToStep(step, doScroll) {
      currentStep = Math.max(1, Math.min(step, totalSteps));
      panels.forEach(function (p) {
        p.classList.toggle('ltj-active', parseInt(p.dataset.step) === currentStep);
      });
      builder.querySelectorAll('.ltj-builder__step-indicator').forEach(function (ind) {
        var s = parseInt(ind.dataset.step);
        var isActive = s === currentStep;
        ind.classList.toggle('ltj-active', isActive);
        ind.classList.toggle('ltj-done', s < currentStep);
        ind.classList.toggle('ltj-step-pending', s > currentStep);
        if (isActive) ind.setAttribute('aria-current', 'step');
        else ind.removeAttribute('aria-current');
        ind.setAttribute('aria-disabled', s > currentStep ? 'true' : 'false');
      });
      var progressBar = builder.querySelector('[data-builder-progress]');
      if (progressBar) progressBar.setAttribute('aria-valuenow', String(currentStep));
      builder.querySelectorAll('.ltj-builder__step-count').forEach(function (el) {
        el.textContent = 'Step ' + currentStep + ' of ' + totalSteps;
      });
      updateSizeGroups();
      updateStoneSizeOptions();
      updateSummary();
      clearStepError(currentStep);
      persistState();
      // No auto-scroll on step change — the page stays where it is so the
      // user keeps their context (especially the live preview on the right).
      // We still move keyboard focus to the new panel title so screen readers
      // + keyboard users land in the right place, but use preventScroll:true
      // so the focus call itself doesn't trigger a page jump either.
      // Skipped on the initial render (doScroll === false) so landing on the
      // page doesn't steal focus from elsewhere.
      if (doScroll !== false) {
        var activePanel = builder.querySelector('.ltj-builder__panel.ltj-active');
        var title = activePanel && activePanel.querySelector('.ltj-builder__panel-title');
        if (title) {
          if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
          try { title.focus({ preventScroll: true }); } catch (e) { /* skip focus on old browsers that lack preventScroll */ }
        }
      }
    }

    function updateSummary() {
      var rows = builder.querySelectorAll('.ltj-builder__summary-rows');
      // Keep this in sync with the data-builder-key values in jewelry-builder.liquid.
      var labels = { jewelry_type:'Item', size:'Bracelet Size', ring_size:'Ring Size', length:'Necklace Length', gemstone:'Gemstone', stone_mm:'Stone Size', metal:'Metal' };
      var order = ['jewelry_type', 'size', 'ring_size', 'length', 'gemstone', 'stone_mm', 'metal'];
      var html = '';
      var bodyLines = [];
      order.forEach(function (k) {
        if (labels[k] && selections[k]) {
          html += '<div class="ltj-builder__summary-row"><span>' + labels[k] + '</span><span>' + escHtml(selections[k]) + '</span></div>';
          bodyLines.push(labels[k] + ': ' + selections[k]);
        }
      });
      rows.forEach(function (el) {
        el.innerHTML = html || '<div class="ltj-builder__summary-row"><span>No selections yet</span><span></span></div>';
      });
      // This hidden field is the message body emailed to the store, so make it human-readable.
      var inp = builder.querySelector('#ltj-builder-summary');
      if (inp) inp.value = bodyLines.length ? ('Custom Jewelry Design Request\n-----------------------------\n' + bodyLines.join('\n')) : '';

      updatePreview();
      persistState();
    }

    /* ---- Live preview: pick the matching SVG, drive metal/stone colors
            and stone scale via CSS variables, and render the chip stack. ---- */
    var preview = builder.querySelector('[data-builder-preview]');

    /* Maps mirror the value strings used in jewelry-builder.liquid.
       Add a new entry here when an option is added to the markup. */
    var METAL_HEX = {
      '18ct Yellow Gold':       '#D4A574',
      '18ct White Gold':        '#D8D4C8',
      '18ct Rose Gold':         '#E0A99C',
      '14ct Yellow Gold':       '#C9985F',
      'Sterling Silver (925)':  '#BFBFBF',
      '9ct Yellow Gold':        '#BF8C50'
    };
    var STONE_HEX = {
      'Diamond (White)': '#EEF2F6',
      'Blue Sapphire':  '#1F4E8A',
      'Ruby':           '#B11226',
      'Emerald':        '#2E8B57',
      'Amethyst':       '#8856B3',
      'Pink Sapphire':  '#E47BA0',
      'Aquamarine':     '#8FCFE0',
      'Topaz (Blue)':   '#6BA8C8'
    };

    function inferStoneHex(name) {
      var n = String(name || '').toLowerCase();
      if (/blue|sodalite|kyanite|azurite/.test(n)) return '#3D6F98';
      if (/turquoise|amazonite|aquamarine|apatite|angelite|chrysocolla/.test(n)) return '#4C9B9B';
      if (/green|moss|jade|malachite|prehnite|peridot|unakite|aventurine/.test(n)) return '#4D8060';
      if (/red|garnet|carnelian|blood/.test(n)) return '#9C463B';
      if (/rose|pink|rhod|morganite|kunzite|sakura/.test(n)) return '#C48392';
      if (/amethyst|charoite|fluorite|super 7|purple/.test(n)) return '#75558D';
      if (/yellow|gold|citrine|pyrite|tiger|sun stone|bronzite|sandstone/.test(n)) return '#AD8040';
      if (/black|obsidian|onyx|shungite|jet|lava|tourmaline/.test(n)) return '#2C2A28';
      if (/white|howlite|opalite|selenite|quartz crystal|calcedony/.test(n)) return '#D7D8D4';
      if (/gray|silver|labradorite/.test(n)) return '#777C7B';
      if (/coral/.test(n)) return '#C96F5C';
      return '#866F61';
    }

    /* Bracelet/earrings gems are painted as small CSS-gradient dots
       stacked inside one shared ::after overlay — there's no separate
       semi-transparent "layer" to slot a texture image into the way the
       necklace pendant has, since each dot is a single opaque gradient
       from highlight to metal rim. Real per-dot <span> elements sidestep
       that: each is sized to its own diameter, so the same
       "background-size:1000%" trick the Step 3 swatches use just works,
       with no manual atlas-cell math needed. */
    var TEX_DOT_DEFS = {
      Earrings: [
        {x:32,y:48,r:18},{x:68,y:48,r:18},{x:32,y:72,r:21},{x:68,y:72,r:21},{x:32,y:59,r:6},{x:68,y:59,r:6}
      ]
    };

    /* Bracelet beads are strung edge-to-edge around a fixed oval track
       (fraction of the preview stage box), the same way a real elastic
       stone-bead bracelet is strung — no gaps, no visible cord, and the
       bead COUNT changes with the chosen stone size so a 4mm and a 12mm
       stone both fill the same wrist circumference touching neighbor to
       neighbor, instead of stretching fixed positions apart. */
    var BRACELET_ELLIPSE = { cx: 0.5, cy: 0.535, rx: 0.34, ry: 0.265 };
    var BRACELET_BASE_BEAD_PX = 32;

    function braceletBeadPositions(stageW, stageH, beadPx) {
      var cx = BRACELET_ELLIPSE.cx * stageW;
      var cy = BRACELET_ELLIPSE.cy * stageH;
      var rx = BRACELET_ELLIPSE.rx * stageW;
      var ry = BRACELET_ELLIPSE.ry * stageH;

      // Sample the oval finely and build a cumulative arc-length table so
      // beads land at even ARC-LENGTH steps — equal angle steps bunch up
      // on the flatter sides of an oval instead of spacing evenly.
      var STEPS = 720;
      var pts = [];
      var cum = [0];
      for (var i = 0; i <= STEPS; i++) {
        var t = (i / STEPS) * Math.PI * 2;
        pts.push({ x: cx + rx * Math.cos(t), y: cy + ry * Math.sin(t) });
        if (i > 0) {
          var dx = pts[i].x - pts[i - 1].x, dy = pts[i].y - pts[i - 1].y;
          cum.push(cum[i - 1] + Math.sqrt(dx * dx + dy * dy));
        }
      }
      var perimeter = cum[cum.length - 1];
      var count = Math.max(8, Math.min(40, Math.round(perimeter / beadPx)));
      var positions = [];
      for (var b = 0; b < count; b++) {
        var target = (perimeter * b) / count;
        var idx = 0;
        while (idx < cum.length - 1 && cum[idx] < target) idx++;
        positions.push({ x: (pts[idx].x / stageW) * 100, y: (pts[idx].y / stageH) * 100 });
      }
      return positions;
    }

    function updateTexDots(stage, type, beadScale) {
      stage.querySelectorAll('.ltj-tex-dot').forEach(function (el) { el.remove(); });
      var scale = beadScale || 1;

      if (type === 'Bracelet') {
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var beadPx = BRACELET_BASE_BEAD_PX * scale;
        braceletBeadPositions(rect.width, rect.height, beadPx).forEach(function (pos) {
          var el = document.createElement('span');
          el.className = 'ltj-tex-dot';
          el.style.left = pos.x + '%';
          el.style.top = pos.y + '%';
          el.style.width = beadPx + 'px';
          el.style.height = beadPx + 'px';
          stage.appendChild(el);
        });
        return;
      }

      var defs = TEX_DOT_DEFS[type];
      if (!defs) return;
      defs.forEach(function (d) {
        var el = document.createElement('span');
        el.className = 'ltj-tex-dot';
        el.style.left = d.x + '%';
        el.style.top = d.y + '%';
        el.style.width = (d.r * 2 * scale) + 'px';
        el.style.height = (d.r * 2 * scale) + 'px';
        stage.appendChild(el);
      });
    }

    /* Stone-size values begin with the inventory diameter in millimetres. */
    var STONE_SCALE = {
      '2':  0.45,
      '3':  0.60,
      '4':  0.75,
      '5':  0.90,
      '6':  1.05,
      '8':  1.30,
      '10': 1.50,
      '12': 1.72,
      '14': 1.95,
      '16': 2.18
    };

    /* Pricing model — directional starting estimates only. The store's
       final quote is determined after consultation. Base = bare metal cost
       per jewelry type, multiplied by the metal tier. Stone base is for a
       reference 4mm round; the stone_mm multiplier scales non-linearly
       because larger gems are disproportionately rarer. */
    var PRICE_BASE_BY_TYPE = {
      'Bracelet': 700,
      'Ring':     500,
      'Necklace': 600,
      'Earrings': 300
    };
    var PRICE_METAL_MULT = {
      '18ct Yellow Gold':       1.40,
      '18ct White Gold':        1.45,
      '18ct Rose Gold':         1.42,
      '14ct Yellow Gold':       1.00,
      'Sterling Silver (925)':  0.25,
      '9ct Yellow Gold':        0.55
    };
    var PRICE_STONE_BASE_4MM = {
      'Diamond (White)': 1200,
      'Blue Sapphire':    400,
      'Ruby':             600,
      'Emerald':          500,
      'Amethyst':          80,
      'Pink Sapphire':    300,
      'Aquamarine':       150,
      'Topaz (Blue)':      80
    };
    var PRICE_STONE_SIZE_MULT = {
      '2': 0.10, '3': 0.30, '4': 1.00, '5': 2.00, '6': 3.50, '8': 7.00,
      '10': 10.00, '12': 14.00, '14': 19.00, '16': 25.00
    };

    function calcPriceRange() {
      var type = selections.jewelry_type;
      if (!type) return null;
      var baseType = PRICE_BASE_BY_TYPE[type] || 0;
      var metalMult = (selections.metal && PRICE_METAL_MULT[selections.metal]) || 1.0;
      var stoneBase = (selections.gemstone && PRICE_STONE_BASE_4MM[selections.gemstone]) || 0;
      var mmKey = selections.stone_mm ? (selections.stone_mm.match(/^(\d+)/) || [])[1] : null;
      var stoneMul = mmKey ? (PRICE_STONE_SIZE_MULT[mmKey] || 0) : 0;

      var typeCost = baseType * metalMult;
      var stoneCost = stoneBase * stoneMul;
      // Earrings are a pair but stones are typically smaller per ear
      if (type === 'Earrings') stoneCost *= 1.7;

      var center = typeCost + stoneCost;
      if (center < 100) return null;

      var low  = Math.max(50, Math.round((center * 0.85) / 50) * 50);
      var high = Math.round((center * 1.40) / 50) * 50;
      return { low: low, high: high };
    }

    function formatUsd(n) {
      try {
        return '$' + n.toLocaleString('en-US');
      } catch (e) {
        return '$' + n;
      }
    }

    function updatePreview() {
      if (!preview) return;

      var type = selections.jewelry_type;
      var svgs = preview.querySelectorAll('.ltj-builder__preview-svg');
      var matched = false;
      svgs.forEach(function (svg) {
        var on = !!type && svg.getAttribute('data-preview-svg') === type;
        svg.classList.toggle('is-active', on);
        if (on) matched = true;
      });
      preview.classList.toggle('has-selection', matched);

      var stage = preview.querySelector('.ltj-builder__preview-stage');
      if (stage) {
        var dotMmKey = selections.stone_mm ? (selections.stone_mm.match(/^(\d+)/) || [])[1] : null;
        var dotScale = (dotMmKey && STONE_SCALE[dotMmKey]) || 1;
        updateTexDots(stage, type, dotScale);
      }

      if (selections.metal && METAL_HEX[selections.metal]) {
        preview.style.setProperty('--ltj-builder-metal', METAL_HEX[selections.metal]);
      }
      if (selections.gemstone) {
        var stoneHex = STONE_HEX[selections.gemstone] || inferStoneHex(selections.gemstone);
        preview.style.setProperty('--ltj-builder-stone', stoneHex);
        // Also publish on the builder root so the Step 4 mm-scaled
        // stones (which aren't descendants of .ltj-builder__preview)
        // can pick up the chosen gemstone color via inheritance.
        builder.style.setProperty('--ltj-builder-stone', stoneHex);

        // Carry the same texture-atlas position used on the Step 3 swatch
        // over to the preview, so the design preview shows real stone
        // texture (not just a flat color) behind the sparkle highlights.
        var stoneSwatch = builder.querySelector(
          '[data-builder-key="gemstone"] [data-value="' + CSS.escape(selections.gemstone) + '"] .ltj-builder__option-swatch--stone'
        );
        if (stoneSwatch) {
          var swatchStyle = getComputedStyle(stoneSwatch);
          var texX = swatchStyle.getPropertyValue('--stone-x').trim() || '0%';
          var texY = swatchStyle.getPropertyValue('--stone-y').trim() || '0%';
          preview.style.setProperty('--ltj-builder-stone-tex-x', texX);
          preview.style.setProperty('--ltj-builder-stone-tex-y', texY);
          builder.style.setProperty('--ltj-builder-stone-tex-x', texX);
          builder.style.setProperty('--ltj-builder-stone-tex-y', texY);
        }
      }
      if (selections.stone_mm) {
        var mmKey = (selections.stone_mm.match(/^(\d+)/) || [])[1];
        var scale = STONE_SCALE[mmKey];
        if (typeof scale === 'number') {
          preview.style.setProperty('--ltj-builder-stone-scale', String(scale));
        }
      }

      /* Chip stack — show one per chosen attribute. The "size" chip
         consolidates whichever sizing key applies to the chosen item type
         so we don't show multiple parallel size keys at once. */
      var sizeKey = selections.size || selections.ring_size || selections.length;
      var chipMap = {
        jewelry_type: selections.jewelry_type,
        size:         sizeKey,
        gemstone:     selections.gemstone,
        stone_mm:     selections.stone_mm,
        metal:        selections.metal
      };
      preview.querySelectorAll('.ltj-builder__preview-chip').forEach(function (chip) {
        var key = chip.getAttribute('data-preview-chip');
        var val = chipMap[key];
        if (val) {
          chip.hidden = false;
          var valEl = chip.querySelector('.ltj-builder__preview-chip-value');
          if (valEl) valEl.textContent = val;
        } else {
          chip.hidden = true;
        }
      });

      /* Price estimate */
      var priceBlock = preview.querySelector('[data-builder-price]');
      var priceRangeEl = preview.querySelector('[data-price-range]');
      if (priceBlock && priceRangeEl) {
        var range = calcPriceRange();
        if (range) {
          priceRangeEl.textContent = formatUsd(range.low) + ' – ' + formatUsd(range.high);
          priceBlock.hidden = false;
        } else {
          priceBlock.hidden = true;
        }
      }
    }

    // Step 2 holds a size group per item type (bracelet length / ring size /
    // necklace length / earrings note). Show only the one matching the Step-1
    // choice and clear selections from the hidden groups so the summary stays
    // relevant. The visible group's pre-selected default is captured into the
    // summary so it isn't silently dropped.
    function updateSizeGroups() {
      var type = selections.jewelry_type;
      builder.querySelectorAll('.ltj-builder__size-group').forEach(function (group) {
        var match = !type || group.dataset.itemType === type;
        group.style.display = match ? '' : 'none';
        var key = group.dataset.builderKey;
        if (!key) return;
        if (match) {
          var preselected = group.querySelector('.ltj-builder__size-btn.ltj-selected');
          if (preselected && !selections[key]) selections[key] = preselected.dataset.value;
        } else {
          delete selections[key];
          group.querySelectorAll('.ltj-builder__size-btn.ltj-selected').forEach(function (b) {
            b.classList.remove('ltj-selected');
          });
        }
      });
      updateSummary();
    }


    // Filter Step 4 using the exact sizes stored on the selected spreadsheet row.
    function updateStoneSizeOptions() {
      var gemstoneGroup = builder.querySelector('[data-builder-key="gemstone"]');
      var sizeGroup = builder.querySelector('[data-builder-key="stone_mm"]');
      if (!gemstoneGroup || !sizeGroup) return;

      var selectedStone = gemstoneGroup.querySelector('.ltj-builder__option.ltj-selected');
      var allowed = selectedStone && selectedStone.dataset.sizes
        ? selectedStone.dataset.sizes.split(',').filter(Boolean)
        : [];

      sizeGroup.querySelectorAll('[data-mm-size]').forEach(function (option) {
        var mm = String(option.dataset.mmSize || '');
        var available = allowed.indexOf(mm) !== -1;
        option.style.display = available ? '' : 'none';
        option.disabled = !available;
        option.setAttribute('aria-hidden', available ? 'false' : 'true');
      });

      if (selections.stone_mm) {
        var currentMm = (selections.stone_mm.match(/^(\d+)/) || [])[1];
        if (!currentMm || allowed.indexOf(currentMm) === -1) {
          delete selections.stone_mm;
          sizeGroup.querySelectorAll('.ltj-selected').forEach(function (option) {
            option.classList.remove('ltj-selected');
          });
        }
      }
    }

    // A step is valid once every VISIBLE option/size group in it has a selection.
    // Hidden size groups (other item types) are skipped; the earrings note has no
    // data-builder-key, so earrings require no size.
    function validateStep(step) {
      var panel = builder.querySelector('.ltj-builder__panel[data-step="' + step + '"]');
      if (!panel) return true;
      var ok = true;
      panel.querySelectorAll('[data-builder-key]').forEach(function (g) {
        if (g.style.display !== 'none' && !selections[g.dataset.builderKey]) ok = false;
      });
      return ok;
    }
    function showStepError(step) {
      var panel = builder.querySelector('.ltj-builder__panel[data-step="' + step + '"]');
      if (!panel) return;
      var err = panel.querySelector('.ltj-builder__error');
      if (!err) {
        err = document.createElement('p');
        err.className = 'ltj-builder__error';
        err.setAttribute('role', 'alert');
        panel.insertBefore(err, panel.querySelector('.ltj-builder__nav'));
      }
      err.textContent = 'Please make a selection to continue.';
      err.classList.add('ltj-show');
    }
    function clearStepError(step) {
      var panel = builder.querySelector('.ltj-builder__panel[data-step="' + step + '"]');
      if (!panel) return;
      var err = panel.querySelector('.ltj-builder__error');
      if (err) err.classList.remove('ltj-show');
    }

    builder.querySelectorAll('.ltj-builder__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var group = opt.closest('[data-builder-key]');
        if (group) {
          group.querySelectorAll('.ltj-builder__option').forEach(function (o) { o.classList.remove('ltj-selected'); });
          selections[group.dataset.builderKey] = opt.dataset.value;
        }
        opt.classList.add('ltj-selected');
        hasInteracted = true;
        // Changing the item type or gemstone re-filters dependent choices live.
        if (group && group.dataset.builderKey === 'jewelry_type') updateSizeGroups();
        if (group && group.dataset.builderKey === 'gemstone') updateStoneSizeOptions();
        updateSummary();
        clearStepError(currentStep);
      });
    });

    builder.querySelectorAll('.ltj-builder__size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-builder-key]');
        if (group) {
          group.querySelectorAll('.ltj-builder__size-btn').forEach(function (b) { b.classList.remove('ltj-selected'); });
          selections[group.dataset.builderKey] = btn.dataset.value;
        }
        btn.classList.add('ltj-selected');
        hasInteracted = true;
        updateSummary();
        clearStepError(currentStep);
      });
    });

    /* Clickable step indicators — let the user jump back to any
       already-reached step. Pending steps (s > currentStep) are
       blocked (aria-disabled is set in goToStep). */
    builder.querySelectorAll('.ltj-builder__step-indicator').forEach(function (ind) {
      ind.addEventListener('click', function () {
        var target = parseInt(ind.dataset.step, 10);
        if (!target) return;
        if (target > currentStep) return;       // forward jumps require Next
        hasInteracted = true;
        goToStep(target);
      });
    });

    builder.querySelectorAll('[data-builder-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Block advancing until the current step's visible group has a selection.
        if (!validateStep(currentStep)) { showStepError(currentStep); return; }
        hasInteracted = true;
        goToStep(currentStep + 1);
      });
    });
    builder.querySelectorAll('[data-builder-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(currentStep - 1); });
    });

    // Let the form post to Shopify normally. We do two things on submit:
    //   (1) ensure the human-readable summary body is captured into the
    //       hidden contact[body] field one last time
    //   (2) stash the selections in sessionStorage so renderConfirmation()
    //       can rehydrate them after Shopify reloads with the success state.
    var orderForm = builder.querySelector('.ltj-builder__order-form form');
    if (orderForm) {
      orderForm.addEventListener('submit', function () {
        updateSummary();
        try { sessionStorage.setItem(SS_SUCCESS_KEY, JSON.stringify(selections)); }
        catch (e) { /* noop */ }
      });
    }

    /* ---- Render the rich success state from saved selections ---- */
    function renderConfirmation() {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(SS_SUCCESS_KEY) || 'null'); }
      catch (e) { /* noop */ }
      if (saved && typeof saved === 'object') selections = saved;

      // Repaint the live preview from the saved selections (also drives
      // the chip stack + price block on the right rail).
      updatePreview();

      // Clone the active preview SVG into the success snapshot card
      var snapshotWrap = builder.querySelector('[data-builder-success-svg]');
      var activeSvg = preview && preview.querySelector('.ltj-builder__preview-svg.is-active');
      if (snapshotWrap && activeSvg) {
        snapshotWrap.innerHTML = '';
        var clone = activeSvg.cloneNode(true);
        clone.classList.add('is-active');
        snapshotWrap.appendChild(clone);
      }

      // Build the summary list (uses the same chip labels as the right rail)
      var summaryEl = builder.querySelector('[data-builder-success-summary]');
      var sizeKey = selections.size || selections.ring_size || selections.length;
      var pairs = [
        ['Item',       selections.jewelry_type],
        ['Size',       sizeKey],
        ['Stone',      selections.gemstone],
        ['Stone Size', selections.stone_mm],
        ['Metal',      selections.metal]
      ];
      if (summaryEl) {
        summaryEl.innerHTML = '';
        pairs.forEach(function (p) {
          if (!p[1]) return;
          var li = document.createElement('li');
          li.innerHTML =
            '<span class="ltj-builder__confirmation-key">' + escHtml(p[0]) + '</span>' +
            '<span class="ltj-builder__confirmation-val">' + escHtml(p[1]) + '</span>';
          summaryEl.appendChild(li);
        });
      }

      // Price
      var priceEl = builder.querySelector('[data-builder-success-price]');
      if (priceEl) {
        var range = calcPriceRange();
        if (range) {
          priceEl.textContent = 'Estimated range: ' + formatUsd(range.low) +
                                ' – ' + formatUsd(range.high) +
                                ' · Final quote after consultation';
          priceEl.hidden = false;
        }
      }

      // Mailto: email yourself a copy of the design
      var mailto = builder.querySelector('[data-builder-success-mailto]');
      if (mailto) {
        var lines = ['Here is my custom design from Legacy Timeless Jewel:', ''];
        pairs.forEach(function (p) { if (p[1]) lines.push(p[0] + ': ' + p[1]); });
        var r2 = calcPriceRange();
        if (r2) {
          lines.push('');
          lines.push('Estimated range: ' + formatUsd(r2.low) + ' – ' + formatUsd(r2.high));
          lines.push('(Final quote after consultation)');
        }
        var subject = 'My Custom Design — Legacy Timeless Jewel';
        mailto.href = 'mailto:?subject=' + encodeURIComponent(subject) +
                      '&body=' + encodeURIComponent(lines.join('\n'));
      }

      // Pass the design to the appointments page on the consultation CTA
      var consult = builder.querySelector('[data-builder-success-consult]');
      if (consult) {
        var consultUrl = consult.getAttribute('href');
        try {
          var u = new URL(consultUrl, window.location.origin);
          var designLines = [];
          pairs.forEach(function (p) { if (p[1]) designLines.push(p[0] + ': ' + p[1]); });
          if (designLines.length) {
            u.searchParams.set('design', designLines.join(' | '));
          }
          consult.setAttribute('href', u.toString());
        } catch (e) { /* noop */ }
      }

      // Clean up so a refresh doesn't keep showing the stale snapshot
      try { sessionStorage.removeItem(SS_SUCCESS_KEY); } catch (e) { /* noop */ }
    }

    /* A fresh design must clear every persisted step and selection before
       navigating away from Shopify's successful contact-form response. */
    var restartButton = builder.querySelector('[data-builder-restart]');
    if (restartButton) {
      restartButton.addEventListener('click', function (event) {
        event.preventDefault();
        try {
          localStorage.removeItem(LS_KEY);
          sessionStorage.removeItem(SS_SUCCESS_KEY);
        } catch (e) { /* private mode / storage unavailable */ }
        selections = {};
        hasInteracted = false;
        var restartHref = restartButton.getAttribute('href') || window.location.pathname;
        window.location.replace(restartHref);
      });
    }

    /* ---- Initial render: hydrate state, then position the user ---- */
    hydrateState();

    // After a successful submit Shopify reloads the page; jump to the final step
    // so the confirmation message (which replaces the form) is visible, and hide the
    // now-empty design summary box so only the confirmation shows.
    if (window.LTJ_BUILDER_SUBMITTED) {
      goToStep(totalSteps, false);
      var summaryBox = builder.querySelector('.ltj-builder__summary');
      if (summaryBox) summaryBox.style.display = 'none';
      renderConfirmation();
    } else {
      goToStep(1, false);
    }
  }

  /* ---- Appointment Booking ---- */
  function initAppointments() {
    var section = document.querySelector('.ltj-appointments');
    if (!section) return;
    var booking = section.querySelector('.ltj-apt-booking');

    var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var DAYS_FULL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    // Eastern Time, Tue–Sun 10am–7pm → last bookable slot 6pm. Value = 24h, label = 12h.
    var SLOTS = [
      { v: '10:00', l: '10:00 AM' }, { v: '11:00', l: '11:00 AM' }, { v: '12:00', l: '12:00 PM' },
      { v: '13:00', l: '1:00 PM' },  { v: '14:00', l: '2:00 PM' },  { v: '15:00', l: '3:00 PM' },
      { v: '16:00', l: '4:00 PM' },  { v: '17:00', l: '5:00 PM' },  { v: '18:00', l: '6:00 PM' }
    ];

    var selectedServiceName = '';

    /* ---- Service cards: first click opens the shell into a two-column
            layout (cards stack on the left, calendar slides in on the right).
            Subsequent clicks just move the selection + pointer. On mobile the
            calendar is moved in DOM to sit right after the selected card. ---- */
    var shell = section.querySelector('[data-apt-shell]');
    var cards = section.querySelectorAll('.ltj-service-card');
    var forLabel = booking ? booking.querySelector('[data-apt-for-svc]') : null;

    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }

    /* Position the pointer arrow vertically on the booking wrap so it
       points at the center of the selected card. Driven by a CSS variable. */
    function updatePointer(card) {
      if (!shell || !booking) return;
      if (isMobile()) return;        // pointer hidden on mobile
      var shellRect = shell.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var bookingRect = booking.getBoundingClientRect();
      // y relative to the booking element (since ::before is positioned inside it)
      var y = (cardRect.top - bookingRect.top) + (cardRect.height / 2);
      booking.style.setProperty('--ltj-apt-pointer-y', y + 'px');
      // Touch the shell rect so it's not eliminated by minifiers
      void shellRect;
    }

    /* Move the booking element directly after the selected card (mobile only). */
    function placeBookingForMobile(card) {
      if (!booking) return;
      if (!isMobile()) return;
      if (card.nextSibling !== booking) {
        if (card.parentNode) card.parentNode.insertBefore(booking, card.nextSibling);
      }
    }

    /* Restore the booking element back to its original spot (desktop). */
    var bookingParent = booking ? booking.parentNode : null;
    var bookingNextSibling = booking ? booking.nextSibling : null;
    function restoreBookingPosition() {
      if (!booking || !bookingParent) return;
      if (booking.parentNode === bookingParent) return;   // already there
      bookingParent.insertBefore(booking, bookingNextSibling);
    }

    /* FLIP transition: animate cards from the row layout to the
       single-column rail by capturing positions, swapping the class,
       capturing again, and animating the difference back to zero. */
    function openShellWithFlip() {
      if (!shell || !cards.length) return;

      var firstRects = [];
      for (var i = 0; i < cards.length; i++) firstRects.push(cards[i].getBoundingClientRect());

      shell.classList.add('is-booking-open');

      // Force a paint with the new layout so we can measure the destination.
      var lastRects = [];
      for (var j = 0; j < cards.length; j++) lastRects.push(cards[j].getBoundingClientRect());

      // Apply inverse transforms (where each card *was*, before transition).
      for (var k = 0; k < cards.length; k++) {
        var dx = firstRects[k].left - lastRects[k].left;
        var dy = firstRects[k].top - lastRects[k].top;
        var fScale = firstRects[k].width / Math.max(1, lastRects[k].width);
        var c = cards[k];
        c.classList.add('ltj-flip-ready');
        c.style.transformOrigin = 'top left';
        c.style.transition = 'none';
        c.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + fScale + ')';
      }

      // Next frame: clear transforms so the CSS transition carries them home.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var m = 0; m < cards.length; m++) {
            cards[m].style.transition = '';
            cards[m].style.transform = '';
          }
        });
      });

      // Clean up inline styles after the transition completes.
      setTimeout(function () {
        for (var n = 0; n < cards.length; n++) {
          cards[n].style.transformOrigin = '';
          cards[n].style.transition = '';
          cards[n].style.transform = '';
        }
      }, 750);
    }

    /* Calendar enters: opacity 0 → 1, slide-in. */
    function revealBooking() {
      if (!booking) return;
      booking.classList.add('ltj-active');
      booking.classList.add('is-revealing');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          booking.classList.remove('is-revealing');
        });
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        // Selection state
        cards.forEach(function (c) { c.classList.remove('ltj-selected'); });
        card.classList.add('ltj-selected');

        // Hidden form input + label
        var nameEl = card.querySelector('.ltj-service-card__name');
        selectedServiceName = nameEl ? nameEl.textContent.trim() : 'Appointment';
        var sf = section.querySelector('#apt-f-service');
        if (sf) sf.value = selectedServiceName;
        if (forLabel) forLabel.textContent = selectedServiceName;

        var firstOpen = shell && !shell.classList.contains('is-booking-open');

        if (booking && firstOpen) {
          // Open the shell with the FLIP animation, then reveal calendar.
          if (isMobile()) {
            placeBookingForMobile(card);
            shell.classList.add('is-booking-open');
          } else {
            openShellWithFlip();
          }
          goAptStep(2);
          revealBooking();
          // After the layout settles, place the pointer arrow.
          setTimeout(function () { updatePointer(card); }, 50);
          setTimeout(function () { updatePointer(card); }, 500);
        } else if (booking) {
          // Already open — just move the pointer / DOM position.
          if (isMobile()) {
            placeBookingForMobile(card);
          } else {
            updatePointer(card);
          }
          goAptStep(2);
        }
      });
    });

    /* If the user lands here via a deep link with ?service=customization
       (e.g. from the jewelry builder's "Book a consultation about this
       design" CTA), auto-click the matching service card so the booking
       flow opens straight to that service. */
    (function autoPickServiceFromURL() {
      try {
        var params = new URLSearchParams(window.location.search);
        var requested = (params.get('service') || '').toLowerCase().trim();
        if (!requested) return;
        var match = null;
        cards.forEach(function (c) {
          if (match) return;
          if ((c.dataset.service || '').toLowerCase() === requested) match = c;
        });
        if (!match) return;
        // Wait a tick so the shell + handlers are fully wired.
        setTimeout(function () { match.click(); }, 80);
      } catch (e) { /* noop */ }
    })();

    /* Keep pointer accurate during resize, and swap mobile/desktop placement. */
    var lastBreakpoint = isMobile();
    window.addEventListener('resize', function () {
      var nowMobile = isMobile();
      if (nowMobile !== lastBreakpoint) {
        lastBreakpoint = nowMobile;
        var selected = section.querySelector('.ltj-service-card.ltj-selected');
        if (selected && shell && shell.classList.contains('is-booking-open')) {
          if (nowMobile) {
            placeBookingForMobile(selected);
            if (booking) booking.style.removeProperty('--ltj-apt-pointer-y');
          } else {
            restoreBookingPosition();
            updatePointer(selected);
          }
        }
      } else if (!nowMobile) {
        var sel = section.querySelector('.ltj-service-card.ltj-selected');
        if (sel) updatePointer(sel);
      }
    }, { passive: true });

    if (!booking) return;

    /* ---- After submit, Shopify reloads with the success state. Fill it from
            sessionStorage (saved just before submit) and reveal it. ---- */
    var successEl = booking.querySelector('[data-apt-success]');
    if (successEl) {
      booking.classList.add('ltj-active');
      try {
        var saved = JSON.parse(sessionStorage.getItem('ltjApt') || '{}');
        var cSvc = booking.querySelector('[data-apt-c-service]');
        var cWhen = booking.querySelector('[data-apt-c-when]');
        var cEmail = booking.querySelector('[data-apt-c-email]');
        var cEmailWrap = booking.querySelector('[data-apt-c-emailwrap]');
        if (cSvc && saved.service) cSvc.textContent = saved.service + ' appointment';
        if (cWhen && saved.whenText) cWhen.textContent = saved.whenText;
        if (cEmail && saved.email) { cEmail.textContent = saved.email; }
        else if (cEmailWrap) { cEmailWrap.style.display = 'none'; }
      } catch (e) {}
      booking.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    /* ---- Elements ---- */
    var stepLabel = booking.querySelector('[data-apt-steplabel]');
    var grid = booking.querySelector('[data-apt-grid]');
    var monthLabel = booking.querySelector('[data-apt-monthlabel]');
    var slotsTitle = booking.querySelector('[data-apt-slotstitle]');
    var slotsList = booking.querySelector('[data-apt-slots]');
    var nextBtn = booking.querySelector('[data-apt-tonext]');
    var summaryEl = booking.querySelector('[data-apt-summary]');
    var fDate = booking.querySelector('#apt-f-date');
    var fTime = booking.querySelector('#apt-f-time');
    if (!grid) return;

    var today = new Date(); today.setHours(0, 0, 0, 0);
    var viewYear = today.getFullYear();
    var viewMonth = today.getMonth();
    var selectedDate = null;   // Date
    var selectedTime = null;   // { v, l }

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function whenText() {
      if (!selectedDate) return '';
      return DAYS_FULL[selectedDate.getDay()] + ', ' + MONTHS[selectedDate.getMonth()] + ' ' + selectedDate.getDate() +
        (selectedTime ? ' at ' + selectedTime.l : '');
    }

    function goAptStep(n) {
      booking.querySelectorAll('.ltj-apt-step').forEach(function (st) {
        st.classList.toggle('ltj-active', parseInt(st.dataset.aptStep, 10) === n);
      });
      if (stepLabel) stepLabel.textContent = (n === 3) ? 'Step 3 of 3 — Your Details' : 'Step 2 of 3 — Select Date';
    }

    function renderCalendar() {
      monthLabel.textContent = MONTHS[viewMonth] + ' ' + viewYear;
      grid.innerHTML = '';
      var startDay = new Date(viewYear, viewMonth, 1).getDay();
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
      for (var i = 0; i < startDay; i++) {
        var blank = document.createElement('span');
        blank.className = 'ltj-apt-cal__cell ltj-apt-cal__cell--empty';
        grid.appendChild(blank);
      }
      for (var d = 1; d <= daysInMonth; d++) {
        var date = new Date(viewYear, viewMonth, d); date.setHours(0, 0, 0, 0);
        var cell = document.createElement('button');
        cell.type = 'button';
        cell.className = 'ltj-apt-cal__cell';
        cell.textContent = d;
        var isPast = date < today;
        var isMonday = date.getDay() === 1;
        if (date.getTime() === today.getTime()) cell.classList.add('ltj-apt-cal__cell--today');
        if (isPast || isMonday) {
          cell.disabled = true;
          cell.classList.add('ltj-apt-cal__cell--disabled');
        } else {
          cell.classList.add('ltj-apt-cal__cell--avail');
          (function (dt) { cell.addEventListener('click', function () { selectDate(dt); }); })(date);
        }
        if (selectedDate && date.getTime() === selectedDate.getTime()) cell.classList.add('ltj-apt-cal__cell--selected');
        grid.appendChild(cell);
      }
    }

    function selectDate(date) {
      selectedDate = date;
      selectedTime = null;
      if (fDate) fDate.value = ymd(date);
      if (fTime) fTime.value = '';
      if (nextBtn) nextBtn.disabled = true;
      renderCalendar();
      renderSlots();
    }

    function renderSlots() {
      if (!selectedDate) {
        slotsTitle.textContent = 'Select a date to see available times';
        slotsList.innerHTML = '';
        return;
      }
      slotsTitle.textContent = DAYS_FULL[selectedDate.getDay()] + ', ' + MONTHS[selectedDate.getMonth()] + ' ' + selectedDate.getDate();
      slotsList.innerHTML = '';
      SLOTS.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ltj-apt-slot';
        b.textContent = s.l;
        b.addEventListener('click', function () {
          slotsList.querySelectorAll('.ltj-apt-slot').forEach(function (x) { x.classList.remove('ltj-apt-slot--selected'); });
          b.classList.add('ltj-apt-slot--selected');
          selectedTime = s;
          if (fTime) fTime.value = s.v;
          if (nextBtn) nextBtn.disabled = false;
        });
        slotsList.appendChild(b);
      });
    }

    var prevBtn = booking.querySelector('[data-apt-prev]');
    var nextMonthBtn = booking.querySelector('[data-apt-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      // don't allow paging before the current month
      if (viewYear === today.getFullYear() && viewMonth === today.getMonth()) return;
      viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; } renderCalendar();
    });
    if (nextMonthBtn) nextMonthBtn.addEventListener('click', function () {
      viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; } renderCalendar();
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (!selectedDate || !selectedTime) return;
      if (summaryEl) summaryEl.textContent = selectedServiceName + ' — 1 hour — ' + whenText() + ' (Eastern Time)';
      goAptStep(3);   // step swaps in place — no scroll
    });

    var backBtn = booking.querySelector('[data-apt-back]');
    if (backBtn) backBtn.addEventListener('click', function () {
      goAptStep(2);   // step swaps in place — no scroll
    });

    /* Appointment-type cards: keep a persistent highlight on the chosen option
       (so it stays visible while filling the rest of the form). */
    var typeCards = booking.querySelectorAll('.ltj-apt-type');
    function syncTypeCards() {
      typeCards.forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        card.classList.toggle('is-selected', !!(input && input.checked));
      });
    }
    typeCards.forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (input) input.addEventListener('change', syncTypeCards);
    });
    syncTypeCards();

    // Persist the selection so the post-reload success state can show it.
    var form = booking.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      try {
        var emailEl = booking.querySelector('#apt-email');
        sessionStorage.setItem('ltjApt', JSON.stringify({
          service: selectedServiceName,
          whenText: whenText(),
          email: emailEl ? emailEl.value : ''
        }));
      } catch (e) {}
    });

    renderCalendar();
    renderSlots();
  }

  /* ---- Discount Pop-up ---- */
  function initPopup() {
    var popup = document.getElementById('ltj-popup');
    if (!popup) return;

    // Guard against duplicate initialization (e.g. Shopify section re-init in the
    // theme editor) so listeners and timers are never attached twice.
    if (popup.dataset.ltjPopupInit === '1') return;
    popup.dataset.ltjPopupInit = '1';

    var box = popup.querySelector('.ltj-popup__box');

    var STORE_KEY = 'ltj_popup_seen';        // dismissal timestamp (14-day suppression)
    var SUB_KEY = 'ltj_popup_subscribed';    // permanent once subscribed
    var frequencyDays = parseInt(popup.dataset.frequency, 10);
    if (isNaN(frequencyDays)) frequencyDays = 14;

    // Fixed trigger timing (per spec):
    //   • never during the first 20s (quiet window)
    //   • then open at ~45% page scroll OR at 25s, whichever comes first
    var MIN_DELAY_MS = 20000;
    var FALLBACK_MS = 25000;
    var SCROLL_RATIO = 0.45;   // ~40–50% scrolled

    var opened = false;
    var lastFocused = null;
    var gateTimer = null, fallbackTimer = null, scrollBound = false;

    function recentlySeen() {
      if (frequencyDays === 0) return false;
      try {
        var ts = parseInt(localStorage.getItem(STORE_KEY), 10);
        if (!ts) return false;
        var days = (Date.now() - ts) / (1000 * 60 * 60 * 24);
        return days < frequencyDays;
      } catch (e) { return false; }
    }
    function markSeen() { try { localStorage.setItem(STORE_KEY, Date.now()); } catch (e) {} }
    function subscribed() { try { return localStorage.getItem(SUB_KEY) === '1'; } catch (e) { return false; } }
    function markSubscribed() { try { localStorage.setItem(SUB_KEY, '1'); } catch (e) {} }

    /* ---- Focus management ---- */
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),' +
                    'textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function focusable() {
      if (!box) return [];
      return Array.prototype.filter.call(box.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab' || !box) return;
      var items = focusable();
      if (!items.length) { e.preventDefault(); box.focus(); return; }
      var first = items[0], last = items[items.length - 1], active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !box.contains(active)) { e.preventDefault(); last.focus(); }
      } else if (active === last || !box.contains(active)) {
        e.preventDefault(); first.focus();
      }
    }

    // Save/restore the body's EXACT prior inline overflow so we don't clobber
    // another component's scroll-lock state.
    var bodyOverflowPrev = null;
    function lockScroll() {
      bodyOverflowPrev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    function unlockScroll() {
      if (bodyOverflowPrev === null) return;   // never locked → nothing to restore
      document.body.style.overflow = bodyOverflowPrev;
      bodyOverflowPrev = null;
    }

    function clearTriggers() {
      if (gateTimer) { clearTimeout(gateTimer); gateTimer = null; }
      if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
      if (scrollBound) { window.removeEventListener('scroll', onScroll); scrollBound = false; }
    }

    function open() {
      if (opened) return;         // can only open once per page view
      opened = true;
      clearTriggers();
      lastFocused = document.activeElement;
      popup.classList.add('ltj-popup--open');
      // Reveal to AT + keyboard BEFORE moving focus in (inert would block .focus()).
      popup.removeAttribute('inert');
      popup.setAttribute('aria-hidden', 'false');
      lockScroll();
      document.addEventListener('keydown', onKeydown, true);
      var items = focusable();
      (items[0] || box || popup).focus();
    }

    function close() {
      var wasOpen = popup.classList.contains('ltj-popup--open');
      clearTriggers();
      popup.classList.remove('ltj-popup--open');
      // Move focus out FIRST, then make it inert (inert can't hold focus).
      if (wasOpen && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('inert', '');
      unlockScroll();
      document.removeEventListener('keydown', onKeydown, true);
      // Start the 14-day suppression window only if the popup actually opened.
      if (opened) markSeen();
    }

    function scrolledEnough() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return false;   // non-scrollable page → rely on the time fallback
      return (window.scrollY || window.pageYOffset) / scrollable >= SCROLL_RATIO;
    }
    function onScroll() { if (scrolledEnough()) open(); }

    function armTriggers() {
      // Enforce the 20s quiet window first; nothing may show before it elapses.
      gateTimer = setTimeout(function () {
        if (opened) return;
        if (scrolledEnough()) { open(); return; }   // already scrolled past ~45%
        window.addEventListener('scroll', onScroll, { passive: true });
        scrollBound = true;
        // 25s overall fallback = 5s after the 20s gate.
        fallbackTimer = setTimeout(open, FALLBACK_MS - MIN_DELAY_MS);
      }, MIN_DELAY_MS);
    }

    // Just subscribed → show the success/code state once, ever (bypasses timing).
    if (window.LTJ_POPUP_JUST_SUBSCRIBED) {
      if (!subscribed()) { open(); }
      markSubscribed();
    } else if (!subscribed() && !recentlySeen()) {
      armTriggers();
    }

    // Dismissal controls: overlay, close (×), "No thanks", success button.
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Back/forward cache restore: keep it hidden if already handled.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && (subscribed() || recentlySeen())) close();
    });

    // Copy code (unchanged behavior).
    var copyBtn = popup.querySelector('[data-popup-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = (document.getElementById('ltj-popup-code') || {}).textContent || '';
        var done = function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('ltj-copied');
          setTimeout(function () { copyBtn.textContent = 'Copy'; copyBtn.classList.remove('ltj-copied'); }, 2000);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code.trim()).then(done).catch(done);
        } else { done(); }
      });
    }
  }

  /* ---- 360° Spin Viewer ---- */
  function initSpinViewer() {
    document.querySelectorAll('[data-spin]').forEach(function (root) {
      var frames;
      try { frames = JSON.parse(root.getAttribute('data-frames')) || []; }
      catch (e) { return; }
      if (frames.length < 2) return;

      var stage = root.querySelector('[data-spin-stage]');
      var img = root.querySelector('[data-spin-img]');
      var loader = root.querySelector('[data-spin-loader]');
      var zoomBtn = root.querySelector('[data-spin-zoom]');
      if (!stage || !img) return;

      var n = frames.length;
      var index = 0;
      var loaded = 0;
      var autoTimer = null;
      var touched = false;

      function show(i) {
        index = ((i % n) + n) % n;
        img.src = frames[index];
      }

      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

      function markTouched() {
        stopAuto();
        if (!touched) { touched = true; root.classList.add('ltj-spin--touched'); }
      }

      // Preload every frame so rotation is instant, then reveal + gentle auto-spin.
      frames.forEach(function (src) {
        var im = new Image();
        im.onload = im.onerror = function () {
          loaded++;
          if (loaded === n) ready();
        };
        im.src = src;
      });

      function ready() {
        if (loader) loader.classList.add('ltj-hide');
        var steps = 0;
        autoTimer = setInterval(function () {
          show(index + 1);
          steps++;
          if (steps >= n) stopAuto();   // one full revolution, then rest
        }, 60);
      }

      /* Drag / swipe to rotate */
      var dragging = false, startX = 0, startIndex = 0, ppf = 4;

      function down(x) {
        if (stage.classList.contains('ltj-zoomed')) return; // zoomed = inspect, not rotate
        markTouched();
        dragging = true;
        startX = x;
        startIndex = index;
        ppf = Math.max(3, stage.clientWidth / (n * 1.15)); // pixels per frame
        stage.classList.add('ltj-grabbing');
      }
      function move(x) {
        if (!dragging) return;
        var steps = Math.round((x - startX) / ppf);
        show(startIndex - steps); // drag right → roll backward (natural grab)
      }
      function up() { dragging = false; stage.classList.remove('ltj-grabbing'); }

      stage.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', up);

      stage.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
      stage.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      stage.addEventListener('touchend', up);

      /* Keyboard */
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { markTouched(); show(index - 1); }
        else if (e.key === 'ArrowRight') { markTouched(); show(index + 1); }
      });

      /* Zoom toggle + pan-by-pointer */
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function () {
          markTouched();
          var z = stage.classList.toggle('ltj-zoomed');
          zoomBtn.textContent = z ? '−' : '+';
          if (!z) img.style.transformOrigin = 'center center';
        });
      }
      stage.addEventListener('mousemove', function (e) {
        if (!stage.classList.contains('ltj-zoomed')) return;
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin =
          (((e.clientX - r.left) / r.width) * 100) + '% ' +
          (((e.clientY - r.top) / r.height) * 100) + '%';
      });
    });
  }

  /* ---- Event Countdown ---- */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (root) {
      var raw = root.getAttribute('data-end');
      if (!raw) return;
      // Accept "YYYY-MM-DD HH:MM" or "YYYY-MM-DD"; parse in the shopper's local time.
      var target = new Date(raw.trim().replace(' ', 'T')).getTime();
      if (isNaN(target)) return;

      var onExpiry = root.getAttribute('data-expiry') || 'message';
      var timer = root.querySelector('[data-cd-timer]');
      var expired = root.querySelector('[data-cd-expired]');
      var dEl = root.querySelector('[data-cd-days]');
      var hEl = root.querySelector('[data-cd-hours]');
      var mEl = root.querySelector('[data-cd-mins]');
      var sEl = root.querySelector('[data-cd-secs]');

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          clearInterval(iv);
          if (onExpiry === 'hide') {
            root.style.display = 'none';
          } else {
            if (timer) timer.style.display = 'none';
            if (expired) expired.style.display = 'block';
          }
          return;
        }
        var s = Math.floor(diff / 1000);
        if (dEl) dEl.textContent = Math.floor(s / 86400);
        if (hEl) hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((s % 3600) / 60));
        if (sEl) sEl.textContent = pad(s % 60);
      }

      var iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---- Video Gallery (click to play) ---- */
  function initVideoGallery() {
    document.querySelectorAll('[data-vg-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-embed');
        if (!src) return;
        var frame = document.createElement('div');
        frame.className = 'ltj-vg__frame';
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', btn.getAttribute('data-title') || 'Video');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        frame.appendChild(iframe);
        if (btn.parentNode) btn.parentNode.replaceChild(frame, btn);
      });
    });
  }

  /* ---- Slideshow swipe / drag (chrome is hidden via CSS) ---- */
  function initSlideshowDrag() {
    document.querySelectorAll('[data-section-type="slideshow-section"]').forEach(function (section) {
      // Desktop below-photo captions: keep the active one in sync with the current
      // slide. Debut dispatches 'slider_slide_changed' (detail = slide index) on the
      // section for every change — autoplay, arrows, indicators, or our swipe.
      var captions = section.querySelectorAll('[data-ltj-slide-captions] .ltj-slide-caption');
      if (captions.length) {
        section.addEventListener('slider_slide_changed', function (e) {
          var idx = Number(e.detail);
          captions.forEach(function (c) {
            c.classList.toggle('ltj-active', Number(c.getAttribute('data-ltj-caption-index')) === idx);
          });
        });
      }

      var wrap = section.querySelector('.slideshow-wrapper');
      var nextBtn = section.querySelector('.slideshow__arrow-next');
      var prevBtn = section.querySelector('.slideshow__arrow-previous');
      if (!wrap || !nextBtn || !prevBtn) return; // single slide → nothing to navigate

      // The pause button only exists when auto-rotate is enabled in the editor.
      var pauseBtn = section.querySelector('.slideshow__pause');
      var PAUSED = 'slideshow__pause--is-paused';
      var THRESHOLD = 40;

      var dragging = false, startX = 0, startY = 0, moved = false, didPause = false, swipeEndAt = 0;

      function pauseAutoplay() {
        if (pauseBtn && !didPause && !pauseBtn.classList.contains(PAUSED)) {
          pauseBtn.click();           // Debut: toggles to paused + stops autoplay
          didPause = true;
        }
      }
      function resumeAutoplay() {
        if (pauseBtn && didPause && pauseBtn.classList.contains(PAUSED)) {
          pauseBtn.click();           // Debut: toggles back to playing + restarts autoplay
        }
        didPause = false;
      }

      function start(x, y) {
        dragging = true; moved = false; startX = x; startY = y;
        wrap.classList.add('ltj-slide-grabbing');
        pauseAutoplay();
      }
      function move(x) {
        if (dragging && Math.abs(x - startX) > 6) moved = true;
      }
      function end(x, y) {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove('ltj-slide-grabbing');
        var dx = x - startX, dy = y - startY;
        if (Math.abs(dx) > THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          swipeEndAt = Date.now();
          (dx < 0 ? nextBtn : prevBtn).click();
        }
        resumeAutoplay();
      }

      // Mouse (desktop)
      wrap.addEventListener('mousedown', function (e) { if (e.button === 0) start(e.clientX, e.clientY); });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', function (e) { end(e.clientX, e.clientY); });

      // Touch (mobile)
      wrap.addEventListener('touchstart', function (e) { var t = e.touches[0]; start(t.clientX, t.clientY); }, { passive: true });
      wrap.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        var t = (e.changedTouches && e.changedTouches[0]) || { clientX: startX, clientY: startY };
        end(t.clientX, t.clientY);
      });

      // After a swipe, swallow only the trailing click on a slide's link/button —
      // NOT the nav arrows we click programmatically (excluding them is what lets
      // a swipe actually navigate).
      wrap.addEventListener('click', function (e) {
        if (Date.now() - swipeEndAt < 300 &&
            e.target.closest('a, button') &&
            !e.target.closest('.slideshow__arrow, [data-slider-button], [data-slider-pause]')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  /* ---- Bootstrap ---- */
  function init() {
    initStickyHeader();
    initBackLink();
    initCart();
    initBackToTop();
    initTicker();
    initMobileDrawer();
    initFAQ();
    initEducationTabs();
    initWishlistButtons();
    initWishlistPage();
    initJewelryBuilder();
    initAppointments();
    initPopup();
    initSpinViewer();
    initCountdown();
    initVideoGallery();
    initSlideshowDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
